import React, { Component } from 'react';
import SearchOrderForm from './searchorderform';
import OrderGrid from './searchordergrid';
import axios from "axios";
import PageSpinner from "../PageSpinner";
import appConfig from '../../config/config';
import { connect } from "react-redux";


const searchOrder = async (values, token) => {

    var a = await axios.post(
        appConfig.apiGateway.searchUrl,
        JSON.stringify(values, null, 2),
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return a.data;
}
class SearchOrder extends Component {
    constructor(props) {
        super(props);
    }
    complete=(response)=> {
        this.props.dispatch({
            type: "LOAD", data:  response });
        this.setState({ ...this.state, data: response, Loading: false, complete: true });
    }
    loading = (isLoading) => {
        this.setState({ ...this.state, Loading: isLoading });
    }
    //Handle loading
    //Handle data from result
    //
    state = { Loading: false, searchCount: 0, data: [], complete:false }


    render() {
        return (
            <>
                <SearchOrderForm complete={this.complete} loading={this.loading} />
                {(this.state.Loading == true) && (< PageSpinner />)}
                < OrderGrid  key={this.props.searchData.data} orders={this.props.searchData.data} />
            </>
        );
    }
}

const mapStateToProps = state => {
    return { searchData: state.searchOrder }
}
var searchOrderForm = connect( mapStateToProps
                        )(SearchOrder)
export default searchOrderForm;